import * as T from './loyaltyToastTypes';
import type { LoyaltyToastState } from './loyaltyToastTypes';
import type { LoyaltyToastAction } from './loyaltyToastActions';

const initialState: LoyaltyToastState = {
  toasts: [],
};

export default function loyaltyToastReducer(
  state = initialState,
  action: LoyaltyToastAction,
): LoyaltyToastState {
  switch (action.type) {
    case T.ADD_TOAST:
      return { ...state, toasts: [...state.toasts, action.payload] };
    case T.REMOVE_TOAST:
      return { ...state, toasts: state.toasts.filter((t) => t.id !== action.payload) };
    default:
      return state;
  }
}
